<div class="container">
  <div class="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[30px] mt-12 mb-12">

    <app-specialisatie-card *ngFor="let spec of specs" [spec]="spec"></app-specialisatie-card>

  </div>
</div>
